import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { map, find, get, round, compact } from 'lodash';
import moment from 'moment';
import { Subheader, CircularProgress, Paper } from 'material-ui';
import { List, ListItem } from 'material-ui/List';

// import { fetchTaxCards, requestTaxDiscountInfo } from 'actions/EmployeeTaxCards';
import { fetchBonuses } from 'actions/EmployeeBonuses';
import PanelMessage from 'components/panels/PanelMessage';
import styles from './styles/Cards';

const Bonuses = ({
  bonusesError, bonusesLoading, bonuses, detailId,
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    // dispatch(fetchTaxCards());
    // dispatch(requestTaxDiscountInfo());
    dispatch(fetchBonuses(detailId));
  }, [dispatch]);

  if (bonusesLoading) return <Paper style={styles.loading}><CircularProgress /></Paper>;

  if (bonusesError) {
    return (<PanelMessage
      type="error"
      iconName="error"
      message={bonusesError.Message || <FormattedMessage id="bank.error" />}
    />);
  }

  const bonusObject = find(bonuses, b => moment(b.Endda).isAfter());

  const bonusKeys = ['PayLifelongEducationBonus', 'PayEducationBonus', 'PayManagementBonus', 'PayLoyaltyBonus'];

  const renderPercent = value => `${round(value * 100)} %`;

  const renderItem = (key) => {
    const bonusValue = get(bonusObject, key);
    return bonusValue
      ? (
        <ListItem key={key} disabled style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span style={{ fontSize: 14 }}><FormattedMessage id={key} />: </span>
          {renderPercent(bonusValue)}
        </ListItem>
      )
      : null;
  };

  const items = compact(map(bonusKeys, item => renderItem(item)));

  if (items.length === 0) {
    return null;
  }

  return (
    <React.Fragment>
      <Subheader style={styles.subheader}><FormattedMessage id="Bonuses" /></Subheader>

      <Paper>
        <List>
          {items}
        </List>
      </Paper>
    </React.Fragment>
  );
};

Bonuses.propTypes = {
  bonusesError: PropTypes.object,
  bonusesLoading: PropTypes.bool,
  bonuses: PropTypes.array,
  detailId: PropTypes.number,
};

const mapStateToProps = ({ EmployeePensionAndUnionReducer }) => ({
  bonuses: EmployeePensionAndUnionReducer.bonuses,
  bonusesError: EmployeePensionAndUnionReducer.bonusesError,
  bonusesLoading: EmployeePensionAndUnionReducer.bonusesLoading,
});

export default connect(mapStateToProps)(Bonuses);



// WEBPACK FOOTER //
// ./src/containers/pay/Bonuses.js